import React from "react";
import { ThemeProvider } from "styled-components";
import ReactDOM from "react-dom/client";
import GlobalStyle from "./GlobalStyle";
import { App } from "./App";
import reportWebVitals from "./reportWebVitals";
import { theme } from "./theme";
import { Provider } from "react-redux";
import { HashRouter } from "react-router-dom";
import { store } from "./store";

// Create the root using ReactDOM.createRoot
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <Provider store={store}>
        <HashRouter>
          <App />
        </HashRouter>
      </Provider>
    </ThemeProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
